import {
  ADD_NEW_MESSAGE,
  CHAT_SINGLE_USER_LIST,
  CHAT_SINGLE_USER_LIST_LOADER,
  CHAT_USER_LIST,
  CHAT_USER_LIST_LOADER,
} from "../actions/type";

const initialState = {
  chatUserList: {},
  chatUserListLoader: false,
  chatSingleUserList: {},
  chatSingleUserListLoader: false,
  //   categoryListById: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CHAT_USER_LIST:
      return {
        ...state,
        chatUserList: payload,
        chatUserListLoader: false,
      };

    case CHAT_USER_LIST_LOADER:
      return {
        ...state,
        chatUserListLoader: payload,
      };
    case CHAT_SINGLE_USER_LIST:
      return {
        ...state,
        chatSingleUserList: payload,
        chatSingleUserListLoader: false,
      };

    case CHAT_SINGLE_USER_LIST_LOADER:
      return {
        ...state,
        chatSingleUserListLoader: payload,
      };

    case ADD_NEW_MESSAGE:
      return {
        ...state,
        chatSingleUserList: {
          ...state.chatSingleUserList,
          data: [...(state.chatSingleUserList?.data || []), payload],
        },
      };

    default:
      return state;
  }
}
